module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_both_location_3column@3x-ad21831e8ba3975df68243bd120f80a2.webp";